<template>
    <div>
        <form-group label="Type" name="subtype_id" :required="true">
            <div class="select">
                <select v-model="value.subtype.id" id="type" class="input">
                    <option :value="null" disabled>Select a leave type</option>
                    <optgroup v-for="type in sortedLeaveTypes" :label="type.name">
                        <option v-for="subtype in type.subtypes" :value="subtype.id">
                            {{subtype.name}}
                        </option>
                    </optgroup>
                </select>
            </div>
        </form-group>

        <form-group label="Start date" name="start" :required="true">
            <datepicker v-model="value.start" :max-date="value.end"/>
        </form-group>

        <form-group label="End date" name="end">
            <datepicker v-model="value.end" :min-date="value.start"/>
        </form-group>

        <div class="flex flex-wrap -mx-2">
            <div class="px-2 w-full md:w-1/2">
                <form-group label="Percentage of Leave" name="percentage.0">
                    <div class="flex items-center">
                        <input type="number"
                               min="0"
                               max="100"
                               placeholder="0"
                               class="input text-right percentage-int-input"
                               v-model="value.percentage[0]"
                               pattern="[0-9](|[0-9](|[0-9]))"
                               @keyup="checkPercentage">
                        <div class="input-group-addon">,</div>
                        <input type="number"
                               min="0"
                               max="99"
                               placeholder="0"
                               class="input w-16"
                               v-model="value.percentage[1]"
                               pattern="([0-9]|[0-9])"
                               @keyup="checkPercentage">
                        <div class="ml-1">%</div>
                    </div>
                <form-group name="percentage.1"></form-group></form-group>
            </div>
        </div>

        <form-group label="Documents" name="documents">
            <file-upload :url="fileUploadUrl"
                         :deleteUrl="fileDeleteUrl"
                         v-model="value.documents"
                         @activeFileUpload="activeFileUpload"
                         accept="application/pdf">
            </file-upload>
        </form-group>

        <form-group label="Comment" name="comment" v-if="!value.hasOwnProperty('id')">
            <textarea class="input" id="comment" rows="5" v-model="value.comment"></textarea>
        </form-group>

    </div>
</template>

<script>
    import FileUpload from '@/components/DragUpload.vue';
    import InteractsWithDates from '../mixins/InteractsWithDates';
    import ResetsPercentage from '../mixins/ResetsPercentage';

    export default {
        mixins: [InteractsWithDates, ResetsPercentage],

        components: {
            FileUpload
        },

        props: ['value'],

        data() {
            return {
                leaveTypes: [],
            }
        },

        methods: {
            activeFileUpload(value) {
                this.$emit('activeFileUpload', value);
            },
        },

        computed: {
            fileUploadUrl() {
                let url = this.$api().getUrl('leave-tracker/pub/documents');

                if (this.value.id) {
                    url += `/${this.value.id}`;
                }

                return url;
            },

            fileDeleteUrl() {
                return this.$api().getUrl('leave-tracker/pub/documents');
            },

            sortedLeaveTypes() {
                return _.sortBy(
                    this.leaveTypes.slice().map((type) => {
                        type.subtypes = _.sortBy(type.subtypes, 'name');
                        return type;
                    }),
                    'name');
            },
        },

        mounted() {
            this.$api('leave-tracker/pub/').get('create')
                .then(({data}) => {
                    this.leaveTypes = data.types;
                });
        }
    }
</script>

<style lang="scss" scoped>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }

    .percentage-int-input {
        min-width: 0;
    }
</style>
